module.exports = __webpack_public_path__ + "static/img/ic_home_pt_gy_yj.a188f57a.png";